var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-nav"},[_vm._l((_vm.blocks),function(block,block_index){return [(block.show)?_c('router-link',{key:_vm._uid+'quick-nav-'+block_index,staticClass:"quick-nav__item",attrs:{"to":{ name: 'detail', hash: '#' + block.key }}},[_c('span',{staticClass:"quick-nav__link"},[_vm._v(_vm._s(block.quick_text))])]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }